import React, { Fragment } from "react";
import { Card, CardBody, Progress, Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { useState } from "react";
import "../../../style/Leaveorduty.css";


const ListMyLeaveDetails = React.memo(({ empTask = [] }) => {
const history = useHistory();
const [showModal, setShowModal] = useState(false);
const [selectedLeave, setSelectedLeave] = useState(null);

  return (
    <Fragment>
      {/* Header */}
      <div
        style={{
          background: "white",
          padding: "15px 20px",
          color: "#000",
          fontSize: "20px",
          fontWeight: "600",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{fontSize:"1.25rem",fontWeight:600}}>Leave Balances</span>
        <div>
      <Button className="apply-btn" style={{ width: '120px', background: "#0f9d8a", border: "1.5px solid rgba(255,255,255,0.6)" }} onClick={() => history.push('/ApplyMyLeaves')}>
                  Apply
                </Button>
          
        </div>
      </div>

      {/* Cards */}
      <div className="container-fluid mt-4">
        <div className="row">
          {[...empTask]
  .sort((a, b) => a.type.localeCompare(b.type))
  .map((el, index) => {
const genleave=(el.noOfLeavesAppliedPerYear +el.noOfLeavesCarryForwarded) > 25 ? 25 : (el.noOfLeavesAppliedPerYear +el.noOfLeavesCarryForwarded);
            const granted = el.type === 'Maternity Leave (ML)' || el.type === 'Special Medical Leave(SML)' ? el.noOfLeavesAppliedPerYear : el.type=='General Leave(GL)'?genleave: el.noOfLeavesPerYear || 0;
            const consumed = el.takenLeave || 0;
            const balance = el.leaveBalance || 0;
            const percent =
              granted > 0 ? Math.round((consumed / granted) * 100) : 0;

            return (
              <div className="col-xl-3 col-lg-4 col-md-6 mb-4" key={index}>
                <Card className="h-100 shadow-sm rounded">
                  <CardBody className="d-flex flex-column">
                    <div className="mb-2">
                      <h6 className="fw-bold mb-0">{el.type}</h6>
                      <small className="text-muted">
                        Granted: {granted}
                      </small>
                    </div>

                    <div className="text-center my-3">
                      <h1 className="fw-bold mb-0">{balance}</h1>
                      <small className="text-muted">Balance</small>
                    </div>

                    <div className="text-center mb-2">
                      <a
  href="#"
  onClick={(e) => {
    e.preventDefault();
    setSelectedLeave(el);
    setShowModal(true);
  }}
  className="text-primary"
  style={{ fontSize: "14px" }}
>
  View Details
</a>

                    </div>

                    <Progress
                      value={percent}
                      className="mb-2"
                      style={{ height: "6px" }}
                    />

                    <small className="text-muted">
                      {consumed} of {granted} Consumed
                    </small>
                  </CardBody>
                </Card>
              </div>
            );
          })}
        </div>
      </div>
      <Modal isOpen={showModal} toggle={() => setShowModal(false)}>
  <ModalHeader toggle={() => setShowModal(false)} style={{color:"black"}}>
    Leave Rules – {selectedLeave?.type}
  </ModalHeader>

  <ModalBody>
    {selectedLeave && (
      <ul className="list-group list-group-flush">
        {selectedLeave.isFirstOccurance && (
          <li className="list-group-item">✔ First Occurrence Rule Enabled</li>
        )}
        {selectedLeave.isLeavesPerHalfYear && (
          <li className="list-group-item">✔ Leaves Limited Per Half Year</li>
        )}
        {selectedLeave.isLeavesPerOrganization && (
          <li className="list-group-item">✔ Leaves Limited Per Organization</li>
        )}
        {selectedLeave.isLeavesPerYear && (
          <li className="list-group-item">✔ Leaves Limited Per Year</li>
        )}
    {selectedLeave.isLeavesPerOrganization && (    <li className="list-group-item">
  ✔ No Of Leaves Per Organization:
  <span className="leave-value"> {selectedLeave.leavesPerOrganization}</span>
</li>)}
         <li className="list-group-item">
  ✔ No Of Leaves Per Year:
  <span className="leave-value"> {selectedLeave.type == 'Maternity Leave (ML)'|| selectedLeave.type == 'Special Medical Leave(SML)' ? selectedLeave.noOfLeavesAppliedPerYear : selectedLeave.noOfLeavesPerYear}</span>
</li>

{selectedLeave.isMaximumAccumulation && (
  <li className="list-group-item">
    ✔ Maximum Accumulation:
    <span className="leave-value"> {selectedLeave.maximumAccumulation}</span>
  </li>
)}

{selectedLeave.isMinimumMaintainedBal && (
  <li className="list-group-item">
    ✔ Minimum Balance Must Be Maintained:
    <span className="leave-value"> {selectedLeave.minimumMaintainedBalance}</span>
  </li>
)}

{selectedLeave.isMinimumWorkingDays && (
  <li className="list-group-item">
    ✔ Minimum Working Days Required:
    <span className="leave-value"> {selectedLeave.minimumWorkingDays}</span>
  </li>
)}

{selectedLeave.isNumberOfTime && (
  <li className="list-group-item">
    ✔ Number of Times Allowed:
    <span className="leave-value"> {selectedLeave.numberOfTimes}</span>
  </li>
)}

{selectedLeave.isServingNoticePeriodCondition && (
  <li className="list-group-item">
    ✔ Serving Notice Period Condition Enabled
  </li>
)}

      </ul>
    )}

    {selectedLeave &&
      !selectedLeave.isFirstOccurance &&
      !selectedLeave.isLeavesPerHalfYear &&
      !selectedLeave.isLeavesPerOrganization &&
      !selectedLeave.isLeavesPerYear &&
      !selectedLeave.isMaximumAccumulation &&
      !selectedLeave.isMinimumMaintainedBal &&
      !selectedLeave.isMinimumWorkingDays &&
      !selectedLeave.isNumberOfTime &&
      !selectedLeave.isServingNoticePeriodCondition && (
        <div className="text-muted text-center">
          No special rules applied for this leave type.
        </div>
      )}
  </ModalBody>
</Modal>

    </Fragment>
  );
});

export default ListMyLeaveDetails;
